import InstitutionSection from "./institution-section";

export default InstitutionSection;
